export const INFLUENCER_APPLICATION_CACHE_SET = "INFLUENCER_APPLICATION_CACHE_SET";
export const INFLUENCER_APPLICATION_CACHE_CLEAR = "INFLUENCER_APPLICATION_CACHE_CLEAR";
export const SAVE_INFLUENCER_APPLICATION = "SAVE_INFLUENCER_APPLICATION";
export const SET_SERVER_ERROR = "SET_SERVER_ERROR";

export function setInfluencerApplicationCache({
  email,
  phoneNumber,
  firstName,
  lastName,
  location,
  username,
  instagramUsername,
  twitterUsername,
  goodFitInfo,
}) {
  return {
    type: INFLUENCER_APPLICATION_CACHE_SET,
    payload: {
      email,
      phoneNumber,
      firstName,
      lastName,
      location,
      username,
      instagramUsername,
      twitterUsername,
      goodFitInfo,
    }
  };
}

export function clearInfluencerApplicationCache() {
  return {
    type: INFLUENCER_APPLICATION_CACHE_CLEAR
  };
}


export function setServerError(serverError) {
  return {
    type: SET_SERVER_ERROR,
    payload: {
      serverError,
    }
  }
}